<template>
  <b-button :variant="variant" :disabled="saveButtonSate !== ''" v-on:click="$emit('submitSaveButton')">
    <font-awesome-icon v-if="saveButtonSate === 'saving'" :icon="['fad', 'spinner-third']" :spin="true" class="mr-1" />
    <font-awesome-icon v-if="saveButtonSate === 'done'" :icon="['fas', 'check']" class="mr-1" />
    <font-awesome-icon v-if="saveButtonSate === 'error'" :icon="['fas', 'times']" class="mr-1" />
    {{text}}
  </b-button>
</template>

<script>
export default {
  name: 'SaveButtonComponent',
  props: {
    saveButtonSate: String
  },
  computed: {
    variant: function() {
      if (this.saveButtonSate === 'saving') {
        return 'primary'
      } else if (this.saveButtonSate === 'done') {
        return 'success'
      } else if (this.saveButtonSate === 'error') {
        return 'danger'
      } else {
        return 'primary'
      }
    },
    text: function() {
      if (this.saveButtonSate === 'saving') {
        return this.$t('global.bitteWarten')
      } else if (this.saveButtonSate === 'done') {
        return this.$t('global.erledigt')
      } else if (this.saveButtonSate === 'error') {
        return this.$t('global.fehler')
      } else {
        return this.$t('global.speichern')
      }
    }
  }
}
</script>